import parseErrors from '@/lib/errors/parseErrors'
import toastErrors from '@/lib/errors/toastErrors'

export const defaultStoreImports = {
  state: ['list', 'page', 'pages', 'count', 'query'],
  getters: ['loading', 'filtered'],
  actions: [
    'fetchList',
    'fetchRemove',
    'prevPage',
    'nextPage',
    'firstPage',
    'lastPage',
  ],
  mutations: ['setQuery'],
}

export default {
  data() {
    return { errors: [] }
  },
  methods: {
    addErrors(errors) {
      this.errors = errors
    }
  },
  async created() {
    if (this.list.length === 0) {
      try {
        await this.fetchList()
      } catch (e) {
        this.addErrors(parseErrors(e))
        toastErrors(e)
      }
    }
  }
}
